import {useMemo} from 'react';
import {Hero} from '.';
import {ProductHeroEntity} from '~/types';
import navigation from '~/lib/navigation';
import {ButtonVariant} from '~/lib/types';

export function ProductHero({data}: {data: ProductHeroEntity}) {
  const {image, product, title, description} = data;

  const heroData = useMemo(() => {
    const price = product?.store?.priceRange?.minVariantPrice;

    const heroContentBlock = {
      title: title || product?.store?.title,
      description: description || (price ? `$${price}` : ''),
      positionRelative: true,
      buttonMarginSmall: true,
      titleType: 'h3' as const,
      buttons:
        product != null
          ? [
              {
                buttonText: 'Shop',
                buttonType: 'primary' as ButtonVariant,
                buttonHref: navigation.productDetail.getPath(
                  product?.store?.slug?.current ?? '',
                ),
                buttonSize: 'md' as const,
                name: 'Shop',
                openInNewTab: false,
              },
            ]
          : [],
    };

    // This is the image added to ProductHero entity manually
    if (image != null) {
      return {
        assetType: 'photo' as const,
        photo: {
          heroImage: image,
          disableFitCrop: true,
          heightAuto: true,
        },
        heroContentBlock,
      };
    }

    // This is product image
    return {
      assetType: 'imageUrl' as const,
      image: {
        url: product?.store?.previewImageUrl ?? '#',
      },
      heroContentBlock,
    };
  }, [product, image, title, description]);

  // Dont render hero if product is not attached
  if (heroData == null) return null;

  return <Hero hero={heroData} autoHeight />;
}
